export default __webpack_public_path__ + "static/arindamLehri13-7c72bd10ee76257e4a0455106a83fbac.jpg";